import { Pipe, PipeTransform } from '@angular/core';
import { inRange } from 'lodash-es';

import { WIFI_STRENGTH_ICON } from '../icons';

@Pipe({
  name: 'iconZigbeeDeviceWifiStrength',
})
export class IconZigbeeDeviceWifiStrengthPipe implements PipeTransform {
  private readonly dbmRanges = [
    {
      from: 0,
      to: -54,
      strength: 'excellent',
    },
    {
      from: -54,
      to: -64,
      strength: 'good',
    },
    {
      from: -64,
      to: -74,
      strength: 'medium',
    },
    {
      from: -74,
      to: -84,
      strength: 'low',
    },
    {
      from: -85,
      to: -Infinity,
      strength: 'off',
    },
  ];

  transform(value: number): string {
    const defaultIcon = WIFI_STRENGTH_ICON['default'];
    const strength = this.strength(value);

    return WIFI_STRENGTH_ICON[strength] || defaultIcon;
  }

  private strength(strengthValue: number): string {
    const strengthRaw = strengthValue ? strengthValue : null;

    if (!strengthRaw || isNaN(strengthRaw)) {
      return 'off';
    }

    const dbmRange = this.dbmRanges.find((range) => inRange(strengthRaw, range.from, range.to));

    return dbmRange ? dbmRange.strength : 'off';
  }
}
